module.exports = __webpack_public_path__ + "img/tree.07007fa7.png";